import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import Repository from '@/types/repositoryType';
import headerObject from '@/types/headerObj';

const endPoint = 'deleteRepo/';
const url = apiUrl + endPoint;

const deleteRepoistory = async (
  repository: Repository,
  headerObj: headerObject
) => {
  try {
    const res = await postWithAuth(
      url,
      {
        RepositoryUUID: repository.UUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    if (
      data.Error === "User doesn't have permission to delete this repository"
    ) {
      console.error(data.Error);
      return false;
    }
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};

export default deleteRepoistory;
